import React, { useState, useEffect, useRef } from 'react';
import { BookOpen, Users, Award, ArrowRight, ChevronRight, X } from 'lucide-react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ContactModal from './components/ContactModal';
import OurPartnersSection from './components/OurPartnersSection';
import OurStory from './components/OurStory';

const AaravamLandingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showNavCTA, setShowNavCTA] = useState(false);
  const heroCTARef = useRef(null);

  useEffect(() => {
    document.title = 'Aaravam';
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (heroCTARef.current) {
        const heroCTABottom = heroCTARef.current.getBoundingClientRect().bottom;
        setShowNavCTA(heroCTABottom < 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 flex justify-between items-center py-6 px-8 md:px-16 border-b border-gray-100 bg-white z-50">
        <div className="flex items-center">
          <svg width="204" height="30" viewBox="0 0 204 30" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-32 md:w-48">
            <path d="M10.3979 30C8.56968 30 6.85575 29.6374 5.25607 28.9122C3.69449 28.187 2.41856 27.1565 1.42828 25.8206C0.476094 24.4466 0 22.8626 0 21.0687C0 19.1603 0.514181 17.5 1.54254 16.0878C2.5709 14.6756 4.03727 13.5878 5.94165 12.8244C7.84602 12.0229 10.0741 11.6221 12.626 11.6221C14.6827 11.6221 16.6442 11.8893 18.5105 12.4237V6.81298H2.17099V0.687025H24.795V29.313H19.4817L18.5105 26.1069H17.9963C17.5393 27.4046 16.6633 28.3779 15.3683 29.0267C14.1114 29.6756 12.4546 30 10.3979 30ZM6.34157 20.7824C6.34157 21.8511 6.77957 22.6908 7.65559 23.3015C8.56968 23.9122 9.80753 24.2176 11.3691 24.2176C12.6641 24.2176 13.8638 24.0267 14.9684 23.645C16.0729 23.2252 16.9299 22.6527 17.5393 21.9275C18.1868 21.2023 18.5105 20.3626 18.5105 19.4084V17.9198C16.6061 17.2328 14.5685 16.8893 12.3975 16.8893C10.5693 16.8893 9.10291 17.2328 7.99837 17.9198C6.89384 18.6069 6.34157 19.5611 6.34157 20.7824ZM39.662 30C37.8338 30 36.1199 29.6374 34.5202 28.9122C32.9586 28.187 31.6827 27.1565 30.6924 25.8206C29.7402 24.4466 29.2641 22.8626 29.2641 21.0687C29.2641 19.1603 29.7783 17.5 30.8067 16.0878C31.835 14.6756 33.3014 13.5878 35.2058 12.8244C37.1102 12.0229 39.3383 11.6221 41.8901 11.6221C43.9469 11.6221 45.9084 11.8893 47.7747 12.4237V6.81298H31.4351V0.687025H54.0591V29.313H48.7459L47.7747 26.1069H47.2605C46.8034 27.4046 45.9274 28.3779 44.6324 29.0267C43.3756 29.6756 41.7187 30 39.662 30ZM35.6057 20.7824C35.6057 21.8511 36.0437 22.6908 36.9197 23.3015C37.8338 23.9122 39.0717 24.2176 40.6332 24.2176C41.9282 24.2176 43.128 24.0267 44.2325 23.645C45.3371 23.2252 46.194 22.6527 46.8034 21.9275C47.4509 21.2023 47.7747 20.3626 47.7747 19.4084V17.9198C45.8703 17.2328 43.8326 16.8893 41.6616 16.8893C39.8334 16.8893 38.367 17.2328 37.2625 17.9198C36.158 18.6069 35.6057 19.5611 35.6057 20.7824ZM59.5566 0.687025H74.5821V6.81298H66.0125V29.313H59.5566V0.687025ZM87.1434 30C85.3152 30 83.6013 29.6374 82.0016 28.9122C80.44 28.187 79.1641 27.1565 78.1738 25.8206C77.2216 24.4466 76.7455 22.8626 76.7455 21.0687C76.7455 19.1603 77.2597 17.5 78.2881 16.0878C79.3164 14.6756 80.7828 13.5878 82.6872 12.8244C84.5916 12.0229 86.8197 11.6221 89.3715 11.6221C91.4283 11.6221 93.3898 11.8893 95.2561 12.4237V6.81298H78.9165V0.687025H101.541V29.313H96.2273L95.2561 26.1069H94.7419C94.2848 27.4046 93.4088 28.3779 92.1138 29.0267C90.857 29.6756 89.2002 30 87.1434 30ZM83.0871 20.7824C83.0871 21.8511 83.5251 22.6908 84.4011 23.3015C85.3152 23.9122 86.5531 24.2176 88.1147 24.2176C89.4096 24.2176 90.6094 24.0267 91.7139 23.645C92.8185 23.2252 93.6754 22.6527 94.2848 21.9275C94.9323 21.2023 95.2561 20.3626 95.2561 19.4084V17.9198C93.3517 17.2328 91.314 16.8893 89.143 16.8893C87.3148 16.8893 85.8484 17.2328 84.7439 17.9198C83.6394 18.6069 83.0871 19.5611 83.0871 20.7824ZM110.98 0.687025L118.35 18.6641H118.864L126.234 0.687025H133.033L121.207 29.313H115.951L104.181 0.687025H110.98ZM143.942 30C142.114 30 140.4 29.6374 138.8 28.9122C137.239 28.187 135.963 27.1565 134.973 25.8206C134.02 24.4466 133.544 22.8626 133.544 21.0687C133.544 19.1603 134.058 17.5 135.087 16.0878C136.115 14.6756 137.582 13.5878 139.486 12.8244C141.39 12.0229 143.618 11.6221 146.17 11.6221C148.227 11.6221 150.188 11.8893 152.055 12.4237V6.81298H135.715V0.687025H158.339V29.313H153.026L152.055 26.1069H151.541C151.084 27.4046 150.208 28.3779 148.913 29.0267C147.656 29.6756 145.999 30 143.942 30ZM139.886 20.7824C139.886 21.8511 140.324 22.6908 141.2 23.3015C142.114 23.9122 143.352 24.2176 144.913 24.2176C146.208 24.2176 147.408 24.0267 148.513 23.645C149.617 23.2252 150.474 22.6527 151.084 21.9275C151.731 21.2023 152.055 20.3626 152.055 19.4084V17.9198C150.15 17.2328 148.113 16.8893 145.942 16.8893C144.114 16.8893 142.647 17.2328 141.543 17.9198C140.438 18.6069 139.886 19.5611 139.886 20.7824ZM193.716 -4.40008e-07C197.03 -4.40008e-07 199.563 1.08779 201.315 3.26336C203.105 5.40076 204 8.47328 204 12.4809V29.313H197.544V14.771C197.544 11.7176 197.163 9.48474 196.402 8.07252C195.678 6.62214 194.421 5.89695 192.631 5.89695C190.65 5.89695 189.241 6.5458 188.403 7.84351C187.565 9.10305 187.146 11.0305 187.146 13.626V29.313H180.69V14.771C180.69 11.7176 180.31 9.48474 179.548 8.07252C178.824 6.62214 177.567 5.89695 175.777 5.89695C173.797 5.89695 172.387 6.5458 171.549 7.84351C170.712 9.10305 170.293 11.0305 170.293 13.626V29.313H163.837V0.687025H169.207L169.95 3.37786H170.464C170.921 2.42367 171.702 1.62214 172.806 0.973282C173.911 0.324427 175.206 -4.40008e-07 176.691 -4.40008e-07C178.558 -4.40008e-07 180.081 0.362595 181.262 1.08779C182.481 1.81298 183.49 2.95801 184.29 4.5229H184.804C185.68 3.11069 186.899 2.00382 188.46 1.20229C190.06 0.400763 191.812 -4.40008e-07 193.716 -4.40008e-07Z" fill="#E16338"/>
          </svg>
        </div>
        
        <button 
          onClick={() => setIsModalOpen(true)}
          className={`bg-[#e16338] text-white py-2 px-4 sm:px-6 rounded-full text-sm font-medium hover:bg-[#d55328] transition ${
            !showNavCTA ? 'opacity-0' : 'opacity-100'
          }`}
        >
          Get in Touch
        </button>
      </nav>

      {/* Hero Section */}
      <section className="pt-24 px-8 md:px-16 flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 mb-8 md:mb-0">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Nurturing Independent Thinkers of Tomorrow
          </h1>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Empower students to become problem-solvers with Aaravam Labs — a transformative program where children develop agency by tackling real-world challenges.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              ref={heroCTARef}
              onClick={() => setIsModalOpen(true)}
              className="bg-[#e16338] text-white py-2 sm:py-3 px-6 sm:px-8 rounded-full text-sm sm:text-base font-medium hover:bg-[#d55328] transition flex items-center justify-center"
            >
              Get in Touch 
            </button>
            <a 
              href="#approach"
              className="border border-[#e16338] text-[#e16338] py-2 sm:py-3 px-6 sm:px-8 rounded-full text-sm sm:text-base font-medium hover:bg-orange-50 transition flex items-center justify-center"
            >
              Learn More <ArrowRight className="ml-2 w-4 h-4 flex-shrink-0" />
            </a>
          </div>
        </div>
    <div className="md:w-1/2 md:pl-12">
    <div className="  overflow-hidden relative rounded-2xl">
       {/* Top edge gradient - hidden on mobile */}
     
       <img 
         src="hero.webp" 
         alt="Students engaged in creative problem solving" 
         className="w-full h-auto relative z-0"
       />
     </div>
  </div>
  </section>
    {/* Key Features Section */}
    <section className="py-16 px-8 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="bg-[#f9f8f3] p-6 rounded-xl shadow-sm">
              <div className="flex items-center gap-4 mb-4">
                <svg width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M1 4H5C5.55228 4 6 4.44772 6 5V19C6 19.5523 5.55228 20 5 20H1C0.44772 20 0 19.5523 0 19V5C0 4.44772 0.44772 4 1 4zM2 13V17C2 17.5523 2.44772 18 3 18C3.55228 18 4 17.5523 4 17V13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13zM8 0H12C12.5523 0 13 0.44772 13 1V19C13 19.5523 12.5523 20 12 20H8C7.44772 20 7 19.5523 7 19V1C7 0.44772 7.44772 0 8 0zM9 11V17C9 17.5523 9.4477 18 10 18C10.5523 18 11 17.5523 11 17V11C11 10.4477 10.5523 10 10 10C9.4477 10 9 10.4477 9 11zM15 2H19C19.5523 2 20 2.44772 20 3V19C20 19.5523 19.5523 20 19 20H15C14.4477 20 14 19.5523 14 19V3C14 2.44772 14.4477 2 15 2zM16 15V17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17V15C18 14.4477 17.5523 14 17 14C16.4477 14 16 14.4477 16 15z" fill="#e16338"/>
                </svg>
                <h3 className="text-xl font-semibold text-gray-800">Seamless Curriculum Integration</h3>
              </div>
              <p className="text-gray-700">
                Aaravam Labs fits effortlessly into your existing curriculum, requiring just 2-3 hours weekly. 
              </p>
            </div>
            
            <div className="p-6  bg-[#f9f8f3] rounded-xl shadow-sm">
              <div className="flex items-center gap-4 mb-4">
                <svg width="40" height="40" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path className="st0" fill="#e16338" d="M341.809,463.578c-1.576,0-3.152-0.074-4.729-0.228l-5.329,14.868c7.654-0.448,15.087-1.049,22.22-1.649l-4.883-13.512C346.684,463.35,344.287,463.578,341.809,463.578z"/>
                    <path className="st0" fill="#e16338" d="M459.672,449.318c-10.887-81.603-53.451-102.028-118.464-122.892c-22.895-7.361-27.924-11.26-27.924-36.334c0-8.709,0,0,0-15.014c11.261-12.544,15.388-10.96,24.919-60.057c19.222,0,18.019-25.08,27.103-47.22c7.353-18.094,1.203-25.454-5.029-28.379c12.682-62.308-4.655-115.759-69.668-125.37C263.512-9.144,217.04,2.49,197.67,6.317c-19.369,3.908-27.176,1.958-27.176,1.958l3.907,27.096c-24.626,29.882-26.656,87.306-23.423,104.425c-5.931,3.226-11.334,10.659-4.281,28.005c9.083,22.14,7.881,47.22,27.103,47.22c9.531,49.097,13.658,47.513,24.919,60.057c0,15.014,0,6.305,0,15.014c0,25.073-5.029,28.973-27.925,36.334C105.782,347.291,63.217,367.715,52.33,449.318c-2.024,14.933,83.708,31.224,203.674,31.224c14.032,0,27.624-0.22,40.608-0.594l10.44-28.98c-11.861-9.985-19.442-24.926-19.442-41.59c0-29.956,24.244-54.28,54.199-54.28c29.956,0,54.199,24.325,54.199,54.28c0,15.688-6.678,29.801-17.419,39.713l8.564,23.87C433.317,466.811,460.794,457.874,459.672,449.318z"/>
                  </g>
                </svg>
                <h3 className="text-xl font-semibold text-gray-800">Student-Driven Experience</h3>
              </div>
              <p className="text-gray-700">
                Students take complete ownership of their learning journey with minimal teacher intervention.
              </p>
            </div>
            
            <div className=" bg-[#f9f8f3] p-6 rounded-xl shadow-sm">
              <div className="flex items-center gap-4 mb-4">
                <svg width="40" height="40" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path fill="#e16338" d="M128.371,334.192c-2.533-2.055-5.094-4.07-7.535-6.254l-0.026,0.054c-0.062-0.054-0.129-0.101-0.191-0.156
      L60.074,457.531l-1.738,4.656l2.289,3.633c1.658,2.523,4.344,4.023,7.342,4.023h1.422l57.861-17.996l22.893,54.785
      c1.42,3.234,4.5,5.367,8.052,5.367c3.395,0,6.473-1.973,7.893-5.055l46.828-100.289l13.844-29.484
      c-0.023-0.004-0.049-0.008-0.072-0.012l0.106-0.226C189.916,371.668,156.213,356.418,128.371,334.192z"/>
                    <path fill="#e16338" d="M404.978,357.258l-13.598-29.242c-0.018,0.012-0.035,0.027-0.053,0.043l-0.105-0.222
      c-27.236,23.996-60.971,40.789-98.039,47.57c-2.611,0.457-5.203,0.996-7.838,1.348l0.028,0.058
      c-0.082,0.012-0.162,0.031-0.244,0.043l60.703,130.09c1.422,3.082,4.5,5.055,7.894,5.055c3.553,0,6.631-2.133,8.051-5.367
      l22.895-54.785l56.756,17.602l1.342,0.394h1.186c2.998,0,5.682-1.5,7.34-4.023l2.369-4.422L404.978,357.258z"/>
                    <path fill="#e16338" d="M429.588,173.664C429.588,77.754,351.832,0,255.922,0C160.01,0,82.256,77.754,82.256,173.664
      c0,95.992,77.754,173.668,173.666,173.668C351.832,347.332,429.588,269.656,429.588,173.664z M255.922,254.106
      c-44.285,0-80.36-36.078-80.36-80.442c0-44.285,36.074-80.359,80.36-80.359c44.363,0,80.438,36.074,80.438,80.359
      C336.36,218.027,300.285,254.106,255.922,254.106z"/>
                  </g>
                </svg>
                <h3 className="text-xl font-semibold text-gray-800">Visible Results</h3>
              </div>
              <p className="text-gray-700">
                Schools see meaningful improvements within months—increased engagement, stronger critical thinking, and better academic performance. 
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      {/* Approach Section */}
      <section id="approach" className="py-24 px-8 md:px-16 -mt-8">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-16 text-gray-900">
            How it <span className="text-[#e16338]">works</span>
          </h2>
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-1/2">
              <img 
                src="section1.webp" 
                alt="Students working on projects" 
                className="w-full h-auto rounded-xl shadow-lg"
              />
            </div>
            <div className="md:w-1/2">
              <div className="relative space-y-12">
                {/* Vertical Timeline Line */}
                <div className="absolute left-6 top-6 h-[calc(100%-180px)] w-[1px] bg-gray-200"></div>

                {/* Timeline Item 1 */}
                <div className="flex items-start gap-6 relative">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#e16338] flex items-center justify-center text-white font-bold relative z-10">1</div>
                  <div className="flex-grow">
                    <h3 className="font-semibold text-gray-800 mb-2">Pre-Program Evaluation</h3>
                    <p className="text-gray-600">Aaravam team visits the school at the outset to evaluate the students' proficiency levels and identify the specific support that school will require.</p>
                  </div>
                </div>
                
                {/* Timeline Item 2 */}
                <div className="flex items-start gap-6 relative">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full border-2 border-[#e16338] flex items-center justify-center text-[#e16338] font-bold relative z-10 bg-white">2</div>
                  <div className="flex-grow">
                    <h3 className="font-semibold text-gray-800 mb-2">Strategizing & Customizing Program</h3>
                    <p className="text-gray-600">Aaravam team will present the findings from evaluation with the school leadership and strategize implementation of a customized program based on the school and students' needs</p>
                  </div>
                </div>
                
                {/* Timeline Item 3 */}
                <div className="flex items-start gap-6 relative">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full border-2 border-[#e16338] flex items-center justify-center text-[#e16338] font-bold relative z-10 bg-white">3</div>
                  <div className="flex-grow">
                    <h3 className="font-semibold text-gray-800 mb-2">Program Starts</h3>
                    <p className="text-gray-600">Every month students work on a new real life problem statement that they themselves identify, with minimal teacher intervention. Students are introduced to creative problem solving frameworks like design thinking.</p>
                  </div>
                </div>
                
                {/* Timeline Item 4 */}
                <div className="flex items-start gap-6 relative">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full border-2 border-green-500 flex items-center justify-center text-green-500 font-bold relative z-10 bg-white">4</div>
                  <div className="flex-grow">
                    <h3 className="font-semibold text-gray-800 mb-2">Annual Assessment</h3>
                    <p className="text-gray-600">At the end of the year, students showcase their work and take part in a comprehensive assessment. Every student develops their own personal portfolio website.</p>
                  </div>
                </div>

                {/* CTA Button */}
                <div className="relative ml-6">
                  <button 
                    onClick={() => setIsModalOpen(true)}
                    className="bg-[#e16338] text-white py-3 px-8 rounded-full font-medium hover:bg-[#d55328] transition inline-flex items-center gap-2"
                  >
                    Schedule a Consultation <ArrowRight className="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-24 px-8 md:px-16 bg-[#f9f8f3]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-16 text-gray-900">
            Program that fits your <span className="text-[#e16338]">needs</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Starter Plan */}
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Starter</h3>
                <p className="text-gray-500">For Schools ready to DIY</p>
              </div>
              <div className="space-y-6">
                <div className="space-y-2">
                  <p className="font-medium text-gray-900 lg:hidden">What's Included:</p>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Pre-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Curriculum
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Facilitator Training
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Post-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Grade 3rd - 6th
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Core Plan */}
            <div className="bg-white rounded-2xl p-6 shadow-lg relative border-2 border-[#e16338]">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-[#e16338] text-white px-4 py-1 rounded-full text-sm font-medium">Most Popular</span>
              </div>
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Core</h3>
                <p className="text-gray-500">For Schools wanting full experience</p>
              </div>
              <div className="space-y-6">
                <div className="space-y-2">
                  <p className="font-medium text-gray-900 lg:hidden">What's Included:</p>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Pre-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Curriculum
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span className="font-semibold">Aaravam Trained Facilitator(s)</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Post-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Grade 3rd - 6th
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Innovator Plan */}
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Innovator</h3>
                <p className="text-gray-500">For Schools aiming for career readiness</p>
              </div>
              <div className="space-y-6">
                <div className="space-y-2">
                  <p className="font-medium text-gray-900 lg:hidden">What's Included:</p>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Pre-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Curriculum
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span className="font-semibold">Aaravam Trained Facilitator(s)</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      Post-program Evaluation
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-[#e16338] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span className="font-semibold">Grade 6th - 9th</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <button 
              onClick={() => setIsModalOpen(true)}
              className="bg-[#e16338] text-white py-3 px-8 rounded-full text-lg font-medium hover:bg-[#d55328] transition inline-flex items-center gap-2"
            >
              Schedule a Consultation <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </section>

      {/* See it in Action Section */}
      <section className="py-16 px-8 md:px-16 bg-[#f9f8f3] overflow-hidden">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-16 text-gray-900">
            See it in <span className="text-[#e16338]">action</span>
          </h2>
          
          <div className="relative">
            <div className="flex animate-scroll space-x-8 hover:pause-animation">
              {/* Project 1 */}
              <div className="min-w-[320px] max-w-xs bg-white rounded-xl shadow p-4 flex-shrink-0 transition-transform duration-500 ease-in-out hover:scale-105">
                <img src="project1.webp" alt="Foosball with waste" className="w-full h-48 object-cover rounded-lg mb-4" />
                <div className="text-lg font-bold text-[#e16338] mb-2">Foosball with waste</div>
                <div className="text-gray-800 text-base">A grade 3 student saw waste around him as a problem and decided to transform that into a fun game for his friends.</div>
              </div>
              {/* Project 2 */}
              <div className="min-w-[320px] max-w-xs bg-white rounded-xl shadow p-4 flex-shrink-0 transition-transform duration-500 ease-in-out hover:scale-105">
                <img src="project2.webp" alt="Puppet show to make learning more engaging" className="w-full h-48 object-cover rounded-lg mb-4" />
                <div className="text-lg font-bold text-[#e16338] mb-2">Puppet show to make learning more engaging</div>
                <div className="text-gray-800 text-base">Grade 4 students noticed that learning was restricted to textbooks, so they created a puppet show to bring texts and stories to life.</div>
              </div>
              {/* Project 3 */}
              <div className="min-w-[320px] max-w-xs bg-white rounded-xl shadow p-4 flex-shrink-0 transition-transform duration-500 ease-in-out hover:scale-105">
                <img src="project4.webp" alt="Reading culture in the community" className="w-full h-48 object-cover rounded-lg mb-4" />
                <div className="text-lg font-bold text-[#e16338] mb-2">Reading culture in the community</div>
                <div className="text-gray-800 text-base">There was a poor culture of reading in the community so grade 4 students interviewed members of the community to understand why it was a problem and how they could solve it.</div>
              </div>
              {/* Project 4 */}
              <div className="min-w-[320px] max-w-xs bg-white rounded-xl shadow p-4 flex-shrink-0 transition-transform duration-500 ease-in-out hover:scale-105">
                <img src="project3.webp" alt="Shapes mat for physical education" className="w-full h-48 object-cover rounded-lg mb-4" />
                <div className="text-lg font-bold text-[#e16338] mb-2">Shapes mat for physical education</div>
                <div className="text-gray-800 text-base">There was no sports class in school so students from grade 4 created a shapes mat so that children to move and use their bodies while learning math concepts.</div>
              </div>
              {/* Duplicate projects for seamless scrolling */}
              {/* Project 1 Duplicate */}
              <div className="min-w-[320px] max-w-xs bg-white rounded-xl shadow p-4 flex-shrink-0 transition-transform duration-500 ease-in-out hover:scale-105">
                <img src="project1.webp" alt="Foosball with waste" className="w-full h-48 object-cover rounded-lg mb-4" />
                <div className="text-lg font-bold text-[#e16338] mb-2">Foosball with waste</div>
                <div className="text-gray-800 text-base">A grade 3 student saw waste around him as a problem and decided to transform that into a fun game for his friends.</div>
              </div>
              {/* Project 2 Duplicate */}
              <div className="min-w-[320px] max-w-xs bg-white rounded-xl shadow p-4 flex-shrink-0 transition-transform duration-500 ease-in-out hover:scale-105">
                <img src="project2.webp" alt="Puppet show to make learning more engaging" className="w-full h-48 object-cover rounded-lg mb-4" />
                <div className="text-lg font-bold text-[#e16338] mb-2">Puppet show to make learning more engaging</div>
                <div className="text-gray-800 text-base">Grade 4 students noticed that learning was restricted to textbooks, so they created a puppet show to bring texts and stories to life.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-320px * 4 - 2rem * 4));
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .hover\:pause-animation:hover {
          animation-play-state: paused;
        }
      `}</style>

      {/* Partners Section */}
      <section id="partners" className="bg-gray-50 py-8 md:py-24 px-8 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="mb-16">
            <OurPartnersSection />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-8 md:px-16 bg-[#e16338]">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
            <div className="bg-white shadow rounded-xl p-6 text-center flex flex-col justify-center">
              <div className="text-xl font-bold text-[#e16338] mb-1">Keerthi Bolar</div>
              <div className="italic text-gray-800 mb-4">Principal of St Mary's High School</div>
              <div className="text-gray-900 text-lg">“For the first time, we saw children systematically look at themselves with the ability to make a change. There is a huge boost in confidence”</div>
            </div>
            <div className="bg-white shadow rounded-xl p-6 text-center flex flex-col justify-center">
              <div className="text-xl font-bold text-[#e16338] mb-1">Mahesh Kumar</div>
              <div className="italic text-gray-800 mb-4">Principal of Mount Everest English High School</div>
              <div className="text-gray-900 text-lg">“Through Aaravam, our children showed dramatic improvement in problem solving and critical thinking.”</div>
            </div>
          </div>

          <div className="text-white text-center pt-8 border-t border-white/20">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 max-w-4xl mx-auto">
              <h2 className="text-3xl md:text-2xl font-bold">Ready to transform education at your school?</h2>
              <button 
                onClick={() => setIsModalOpen(true)}
                className="bg-white text-[#e16338] py-2 sm:py-3 px-6 sm:px-8 rounded-full text-sm sm:text-base font-medium hover:bg-gray-100 transition inline-flex items-center whitespace-nowrap"
              >
                Schedule a Consultation <ChevronRight className="ml-1 w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="bg-gray-900 text-gray-300 py-12 px-8 md:px-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <svg width="204" height="30" viewBox="0 0 204 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.3979 30C8.56968 30 6.85575 29.6374 5.25607 28.9122C3.69449 28.187 2.41856 27.1565 1.42828 25.8206C0.476094 24.4466 0 22.8626 0 21.0687C0 19.1603 0.514181 17.5 1.54254 16.0878C2.5709 14.6756 4.03727 13.5878 5.94165 12.8244C7.84602 12.0229 10.0741 11.6221 12.626 11.6221C14.6827 11.6221 16.6442 11.8893 18.5105 12.4237V6.81298H2.17099V0.687025H24.795V29.313H19.4817L18.5105 26.1069H17.9963C17.5393 27.4046 16.6633 28.3779 15.3683 29.0267C14.1114 29.6756 12.4546 30 10.3979 30ZM6.34157 20.7824C6.34157 21.8511 6.77957 22.6908 7.65559 23.3015C8.56968 23.9122 9.80753 24.2176 11.3691 24.2176C12.6641 24.2176 13.8638 24.0267 14.9684 23.645C16.0729 23.2252 16.9299 22.6527 17.5393 21.9275C18.1868 21.2023 18.5105 20.3626 18.5105 19.4084V17.9198C16.6061 17.2328 14.5685 16.8893 12.3975 16.8893C10.5693 16.8893 9.10291 17.2328 7.99837 17.9198C6.89384 18.6069 6.34157 19.5611 6.34157 20.7824ZM39.662 30C37.8338 30 36.1199 29.6374 34.5202 28.9122C32.9586 28.187 31.6827 27.1565 30.6924 25.8206C29.7402 24.4466 29.2641 22.8626 29.2641 21.0687C29.2641 19.1603 29.7783 17.5 30.8067 16.0878C31.835 14.6756 33.3014 13.5878 35.2058 12.8244C37.1102 12.0229 39.3383 11.6221 41.8901 11.6221C43.9469 11.6221 45.9084 11.8893 47.7747 12.4237V6.81298H31.4351V0.687025H54.0591V29.313H48.7459L47.7747 26.1069H47.2605C46.8034 27.4046 45.9274 28.3779 44.6324 29.0267C43.3756 29.6756 41.7187 30 39.662 30ZM35.6057 20.7824C35.6057 21.8511 36.0437 22.6908 36.9197 23.3015C37.8338 23.9122 39.0717 24.2176 40.6332 24.2176C41.9282 24.2176 43.128 24.0267 44.2325 23.645C45.3371 23.2252 46.194 22.6527 46.8034 21.9275C47.4509 21.2023 47.7747 20.3626 47.7747 19.4084V17.9198C45.8703 17.2328 43.8326 16.8893 41.6616 16.8893C39.8334 16.8893 38.367 17.2328 37.2625 17.9198C36.158 18.6069 35.6057 19.5611 35.6057 20.7824ZM59.5566 0.687025H74.5821V6.81298H66.0125V29.313H59.5566V0.687025ZM87.1434 30C85.3152 30 83.6013 29.6374 82.0016 28.9122C80.44 28.187 79.1641 27.1565 78.1738 25.8206C77.2216 24.4466 76.7455 22.8626 76.7455 21.0687C76.7455 19.1603 77.2597 17.5 78.2881 16.0878C79.3164 14.6756 80.7828 13.5878 82.6872 12.8244C84.5916 12.0229 86.8197 11.6221 89.3715 11.6221C91.4283 11.6221 93.3898 11.8893 95.2561 12.4237V6.81298H78.9165V0.687025H101.541V29.313H96.2273L95.2561 26.1069H94.7419C94.2848 27.4046 93.4088 28.3779 92.1138 29.0267C90.857 29.6756 89.2002 30 87.1434 30ZM83.0871 20.7824C83.0871 21.8511 83.5251 22.6908 84.4011 23.3015C85.3152 23.9122 86.5531 24.2176 88.1147 24.2176C89.4096 24.2176 90.6094 24.0267 91.7139 23.645C92.8185 23.2252 93.6754 22.6527 94.2848 21.9275C94.9323 21.2023 95.2561 20.3626 95.2561 19.4084V17.9198C93.3517 17.2328 91.314 16.8893 89.143 16.8893C87.3148 16.8893 85.8484 17.2328 84.7439 17.9198C83.6394 18.6069 83.0871 19.5611 83.0871 20.7824ZM110.98 0.687025L118.35 18.6641H118.864L126.234 0.687025H133.033L121.207 29.313H115.951L104.181 0.687025H110.98ZM143.942 30C142.114 30 140.4 29.6374 138.8 28.9122C137.239 28.187 135.963 27.1565 134.973 25.8206C134.02 24.4466 133.544 22.8626 133.544 21.0687C133.544 19.1603 134.058 17.5 135.087 16.0878C136.115 14.6756 137.582 13.5878 139.486 12.8244C141.39 12.0229 143.618 11.6221 146.17 11.6221C148.227 11.6221 150.188 11.8893 152.055 12.4237V6.81298H135.715V0.687025H158.339V29.313H153.026L152.055 26.1069H151.541C151.084 27.4046 150.208 28.3779 148.913 29.0267C147.656 29.6756 145.999 30 143.942 30ZM139.886 20.7824C139.886 21.8511 140.324 22.6908 141.2 23.3015C142.114 23.9122 143.352 24.2176 144.913 24.2176C146.208 24.2176 147.408 24.0267 148.513 23.645C149.617 23.2252 150.474 22.6527 151.084 21.9275C151.731 21.2023 152.055 20.3626 152.055 19.4084V17.9198C150.15 17.2328 148.113 16.8893 145.942 16.8893C144.114 16.8893 142.647 17.2328 141.543 17.9198C140.438 18.6069 139.886 19.5611 139.886 20.7824ZM193.716 -4.40008e-07C197.03 -4.40008e-07 199.563 1.08779 201.315 3.26336C203.105 5.40076 204 8.47328 204 12.4809V29.313H197.544V14.771C197.544 11.7176 197.163 9.48474 196.402 8.07252C195.678 6.62214 194.421 5.89695 192.631 5.89695C190.65 5.89695 189.241 6.5458 188.403 7.84351C187.565 9.10305 187.146 11.0305 187.146 13.626V29.313H180.69V14.771C180.69 11.7176 180.31 9.48474 179.548 8.07252C178.824 6.62214 177.567 5.89695 175.777 5.89695C173.797 5.89695 172.387 6.5458 171.549 7.84351C170.712 9.10305 170.293 11.0305 170.293 13.626V29.313H163.837V0.687025H169.207L169.95 3.37786H170.464C170.921 2.42367 171.702 1.62214 172.806 0.973282C173.911 0.324427 175.206 -4.40008e-07 176.691 -4.40008e-07C178.558 -4.40008e-07 180.081 0.362595 181.262 1.08779C182.481 1.81298 183.49 2.95801 184.29 4.5229H184.804C185.68 3.11069 186.899 2.00382 188.46 1.20229C190.06 0.400763 191.812 -4.40008e-07 193.716 -4.40008e-07Z" fill="#E16338"/>
              </svg>
            </div>
            <p className="mb-4">Nurturing independent thinkers of tomorrow through experiential learning.</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li>aaravam.education@gmail.com</li>
              <li>+91 6385920981</li>
              <li>Bangalore, India</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Connect With Us</h4>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/aaravam_org/" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#e16338] transition" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Instagram</span>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white">
                  <path d="M12 2.16C15.2 2.16 15.58 2.16 16.9 2.24C19.68 2.4 21.6 4.4 21.76 7.1C21.84 8.42 21.84 8.8 21.84 12C21.84 15.2 21.84 15.58 21.76 16.9C21.6 19.6 19.68 21.6 16.9 21.76C15.58 21.84 15.2 21.84 12 21.84C8.8 21.84 8.42 21.84 7.1 21.76C4.32 21.6 2.4 19.6 2.24 16.9C2.16 15.58 2.16 15.2 2.16 12C2.16 8.8 2.16 8.42 2.24 7.1C2.4 4.4 4.32 2.4 7.1 2.24C8.42 2.16 8.8 2.16 12 2.16ZM12 0C8.74 0 8.33 0 7.05 0.08C3.17 0.32 0.32 3.17 0.08 7.05C0 8.33 0 8.74 0 12C0 15.26 0 15.67 0.08 16.95C0.32 20.83 3.17 23.68 7.05 23.92C8.33 24 8.74 24 12 24C15.26 24 15.67 24 16.95 23.92C20.83 23.68 23.68 20.83 23.92 16.95C24 15.67 24 15.26 24 12C24 8.74 24 8.33 23.92 7.05C23.68 3.17 20.83 0.32 16.95 0.08C15.67 0 15.26 0 12 0ZM12 5.84C8.6 5.84 5.84 8.6 5.84 12C5.84 15.4 8.6 18.16 12 18.16C15.4 18.16 18.16 15.4 18.16 12C18.16 8.6 15.4 5.84 12 5.84ZM12 16C9.8 16 8 14.2 8 12C8 9.8 9.8 8 12 8C14.2 8 16 9.8 16 12C16 14.2 14.2 16 12 16ZM18.4 5.6C18.4 4.72 17.68 4 16.8 4C15.92 4 15.2 4.72 15.2 5.6C15.2 6.48 15.92 7.2 16.8 7.2C17.68 7.2 18.4 6.48 18.4 5.6Z" fill="currentColor"/>
                </svg>
              </a>
            </div>
            <div className="mt-4">
              <a 
                href="/our-story" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white hover:text-[#e16338] transition"
              >
                Our Story
              </a>
            </div>
          </div>
        </div>
        <div className="max-w-6xl mx-auto pt-8 mt-8 border-t border-gray-800 text-center text-sm">
          <p>© 2025 Aaravam Labs. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AaravamLandingPage />} />
        <Route path="/our-story" element={<OurStory />} />
      </Routes>
    </Router>
  );
};

export default App;